export class WebhookV1StandardPayloadSnapshotAccessDeniedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotAccessDenied",
            "baseName": "snapshotAccessDenied",
            "type": "WebhookV1SnapshotAccessDeniedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadSnapshotAccessDeniedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
